<template>
  <div>
    <el-card>
      <div class="forms">
        <el-form :inline="true" :model="form" class="demo-form-inline">
          <el-form-item label="直播渠道">
            <el-select v-model="form.channelId" clearable>
              <el-option
                v-for="(item, index) in selectListData"
                :label="item.channelName"
                :value="item.id"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="展示时间段">
            <el-date-picker
              v-model="showTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm"
              clearable
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button class="btnBackgory" @click="searchData">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-popconfirm
              title="您确定要删除多条数据吗？"
              @confirm="deleteData"
            >
              <el-button class="white" slot="reference">删除</el-button>
            </el-popconfirm>
          </el-form-item>
          <!-- <el-button class="btnBorderColor" @click="exportData">导入</el-button> -->
          <el-form-item>
            <el-button @click="channelManage" class="btnBorderColor"
              >渠道管理</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button class="btnBackgory" @click="addHomeData('dialogForm')"
              >新增直播</el-button
            >
          </el-form-item>
        </el-form>

        <el-table
          ref="table"
          v-loading="loading"
          :data="tableData"
          border
          tooltip-effect="dark"
          style="width: 100%; margin-top: 20px"
          @selection-change="handleSelectionChange"
          max-height="650"
        >
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column
            prop="channelName"
            label="渠道名称"
            min-width="140"
            align="center"
          />
          <el-table-column
            prop="liveTitle"
            label="标题"
            min-width="240"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            prop="liveStartTimeAndEndTime"
            label="展示时间"
            min-width="240"
            align="center"
          />
          <el-table-column
            prop="jumpLink"
            label="跳转链接"
            min-width="160"
            show-overflow-tooltip
            align="center"
          >
            <template #default="scope">
              <a class="aHref" href="JavaScript:;">{{ scope.row.jumpLink }}</a>
            </template>
          </el-table-column>
          <el-table-column
            prop="imgUrl"
            label="图片"
            min-width="80"
            align="center"
          >
            <template #default="scope">
              <img
                style="width: 50px; height: 50px"
                :src="`${uploadUrl}+${scope.row.imgUrl}`"
                alt=""
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="updatedTime"
            label="变更时间"
            min-width="120"
            align="center"
          />
          <el-table-column
            prop="updatedBy"
            label="变更人"
            min-width="120"
            align="center"
          />
          <el-table-column
            prop="status"
            label="状态"
            min-width="140"
            align="center"
            fixed="right"
          />
          <el-table-column
            prop="remark"
            label="备注"
            show-overflow-tooltip
            min-width="260"
            align="center"
          />
          <el-table-column
            label="操作"
            min-width="100"
            align="center"
            fixed="right"
          >
            <template #default="scope">
              <div class="operate">
                <div class="btn" @click="edit(scope.row)">编辑</div>
                <div class="btn" @click="changeStatus(scope.row)">
                  {{ scope.row.awaitLiveStatus }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageContainer">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageData.page"
            :page-sizes="[10, 20, 40, 60, 80, 100]"
            :page-size="pageData.pageSize"
            layout="total, prev, pager, next,sizes"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>

    <el-dialog
      :title="`${title}直播`"
      :visible.sync="dialogVisible"
      width="750px"
      center
      @close="cancelBtn('dialogForm')"
    >
      <div class="forms">
        <el-form
          :model="dialogForm"
          :rules="dialogRules"
          ref="dialogForm"
          label-width="160px"
          class="demo-dialogForm"
          label-position="left"
        >
          <el-form-item label="选择渠道" prop="channelId">
            <el-select v-model="dialogForm.channelId" clearable>
              <el-option
                v-for="item in selectListData"
                :label="item.channelName"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="视频标题" prop="liveTitle">
            <el-input
              v-model="dialogForm.liveTitle"
              placeholder="请输入视频标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="开始时间" prop="liveStartTime" clearable>
            <el-date-picker
              v-model="dialogForm.liveStartTime"
              type="datetime"
              placeholder="开始时间"
              value-format="yyyy-MM-dd HH:mm"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="liveEndTime" clearable>
            <el-date-picker
              v-model="dialogForm.liveEndTime"
              type="datetime"
              placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="图片跳转链接" prop="jumpLink">
            <el-input
              v-model="dialogForm.jumpLink"
              placeholder="请输入网址"
            ></el-input>
            <!-- <div>网址格式：http:// 或 https://</div> -->
          </el-form-item>
          <el-form-item label="请选择图片" prop="imgUrl" ref="imgUpload">
            <!-- 上传 -->
            <el-upload
              class="avatar-uploader"
              :action="`${upload}/file/uploadNew`"
              :show-file-list="false"
              :on-success="uploadSuccess"
              list-type="picture-card"
            >
              <img v-if="imgUrl" :src="imgUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="备注信息">
            <el-input
              type="textarea"
              v-model="dialogForm.remark"
              placeholder="请输入备注内容"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item> -->
          <div class="footerBtn">
            <el-button class="dialogWhite" @click="cancelBtn('dialogForm')"
              >取 消</el-button
            >
            <el-button
              class="dialogBtnBackgory"
              @click="submitForm('dialogForm')"
              >确 定</el-button
            >
          </div>

          <!-- </el-form-item> -->
        </el-form>
      </div>
    </el-dialog>
    <Channel ref="channelDialog"></Channel>

    <Export
      ref="exportDialog"
      :type="type"
      :downloadTitle="downloadTitle"
      :getSearchList="getSearchList"
    ></Export>
  </div>
</template>

<script>
import apis from "@/apis/gzh.js";
import Channel from "./components/channel.vue";
import Export from "../exportFile/export.vue";
import moment from "moment";
export default {
  name: "liveStreaming",
  components: {
    Channel,
    Export
  },
  data() {
    return {
      form: {
        channelId: "",
        startTime: "",
        endTime: ""
      },
      uploadUrl: "",
      upload: "",
      showTime: [],
      ids: [],
      title: "新增",
      selectListData: [],
      loading: false,
      pageData: {
        page: 1,
        pageSize: 10
      },
      total: 0,
      tableData: [],
      dialogVisible: false,
      dialogForm: {
        channelId: "",
        liveTitle: "",
        liveStartTime: "",
        liveEndTime: "",
        jumpLink: "",
        imgUrl: "",
        remark: ""
      },
      imgUrl: "",
      dialogRules: {
        channelId: [
          { required: true, message: "请选择渠道", trigger: "change" }
        ],
        liveTitle: [
          { required: true, message: "请输入视频标题", trigger: "blur" }
        ],
        liveStartTime: [{ required: true, message: "请选择开始时间" }],
        liveEndTime: [{ required: true, message: "请选择结束时间" }],
        jumpLink: [
          { required: true, message: "请输入图片跳转链接", trigger: "blur" }
        ],
        imgUrl: [{ required: true, message: "请选择图片" }]
      },
      liveStatusList: [],
      type: "gzh_live",
      downloadTitle: "直播导入模板"
    };
  },
  mounted() {
    this.upload = apis.upload;
    this.uploadUrl = apis.uploadUrl;
    this.getSeleteDataList();
    this.getSearchList(this.pageData);
  },
  methods: {
    // 获取 下拉 数据
    getSeleteDataList() {
      apis.liveChannelPageList().then(res => {
        if (res.code === 200) {
          this.selectListData = res.data;
        }
      });
    },

    // table 选中
    handleSelectionChange(val) {
      this.ids = val.map(item => item.id);
    },
    // 获取 table 数据
    getSearchList(json) {
      this.loading = true;
      // 直播状态
      apis.getLiveStatus().then(res => {
        if (res.code === 200) {
          this.liveStatusList = res.data;
          this.loading = false;
        }
      });
      //列表数据
      apis.liveStreamingDetailList(json).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.map(item => {
            if (item.status === "待展出") {
              item.awaitLiveStatus = "展出中";
            } else if (item.status === "展出中") {
              item.awaitLiveStatus = "已结束";
            } else if (item.status === "已停止") {
              item.awaitLiveStatus = "停止";
            } else if (item.status === "已结束") {
              item.awaitLiveStatus = "已停止";
            }
            return item;
          });
          this.total = res.total;
        }
      });
    },
    // 搜索
    searchData() {
      if (this.showTime?.length) {
        this.form.startTime = this.showTime[0];
        this.form.endTime = this.showTime[1];
      } else {
        this.form.startTime = "";
        this.form.endTime = "";
      }
      const json = {
        ...this.pageData,
        ...this.form
      };
      this.getSearchList(json);
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getSearchList({ ...this.pageData, ...this.form });
    },
    // 当前页
    handleCurrentChange(val) {
      this.pageData.page = val;
      this.getSearchList({ ...this.pageData, ...this.form });
    },
    // 渠道管理
    channelManage() {
      this.$refs.channelDialog.getTableData();
      this.$refs.channelDialog.dialogVisible = true;
    },
    // 新增
    addHomeData(formName) {
      this.getSeleteDataList();
      this.dialogVisible = true;
      this.title = "新增";
      this.dialogForm = {};
      this.imgUrl = "";
      this.$refs[formName]?.resetFields();
    },
    uploadSuccess(res) {
      if (res.code === 200) {
        this.dialogForm.imgUrl = res.data.id;
        this.imgUrl = apis.uploadUrl + res.data.id;
        this.$refs["imgUpload"].clearValidate();
      }
    },

    // 批量 删除
    deleteData() {
      if (this.ids.length) {
        apis.liveDeleteOnlyData(this.ids).then(res => {
          if (res.code === 200) {
            this.getSearchList(this.pageData);
            this.$message({
              message: "删除成功",
              type: "success"
            });
          }
        });
      }
    },

    // 确认 添加
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const startDate = moment(this.dialogForm.liveStartTime);
          const endDate = moment(this.dialogForm.liveEndTime);
          if (!endDate.isAfter(startDate)) {
            return this.$message({
              message: "开始时间不能早于等于结束时间",
              type: "warning"
            });
          }
          const json = {
            ...this.dialogForm
          };
          apis.liveAddAndEdit(json).then(res => {
            if (res.code === 200) {
              this.getSearchList(this.pageData);
              this.dialogVisible = false;
              const msg = this.dialogForm.id ? "修改" : "新增";
              this.$message({
                message: `${msg}成功`,
                type: "success"
              });
            }
          });
        }
      });
    },
    //dialog 取消按钮
    cancelBtn(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    // 编辑
    edit(row) {
      this.imgUrl = apis.uploadUrl + row.file.id;
      this.dialogForm = JSON.parse(
        JSON.stringify({
          id: row.id,
          channelId: row.channelId,
          liveTitle: row.liveTitle,
          liveStartTime: row.liveStartTimeAndEndTime.split("--")[0],
          liveEndTime: row.liveStartTimeAndEndTime.split("--")[1],
          jumpLink: row.jumpLink,
          imgUrl: row.file.id,
          remark: row.remark
        })
      );
      this.dialogVisible = true;
      this.title = "编辑";
    },
    // 修改 状态
    changeStatus(row) {
      const value = Object.keys(this.liveStatusList).filter(item => {
        if (this.liveStatusList[item] === row.awaitLiveStatus) {
          return item;
        }
      });
      const json = {
        id: row.id,
        status: value[0]
      };
      apis.liveAddAndEdit(json).then(res => {
        if (res.code === 200) {
          this.getSearchList(this.pageData);
          this.$message({
            message: "修改直播状态成功",
            type: "success"
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-card {
  margin: 20px;
}
// // 1 解决 table 表头和内容错误
// ::v-deep .el-table {
//   th.gutter,
//   colgroup.gutter {
//     width: 0px !important; //此处的宽度值，对应你自定义滚动条的宽度即可
//   }
// }
// // 2 关键css代码
// ::v-deep .el-table__header colgroup col[name="gutter"] {
//   display: table-cell !important;
// }
::v-deep .el-dialog__title {
  display: flex;
  align-items: center;
  font-size: 29px;
  &::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 29px;
    background-color: #008754;
    margin-right: 10px;
  }
}
.forms {
  .el-button--mini {
    margin-right: 20px;
  }
  .btnBackgory {
    width: 181px;
    height: 54px;
    background-color: #008754;
    color: white;
  }
  .white {
    width: 181px;
    height: 54px;
  }
  .btnBorderColor {
    width: 181px;
    height: 54px;
    color: #008754;
    border-color: #008754;
  }

  ::v-deep .el-form {
    .left {
      .el-input--mini .el-input__inner {
        width: 295px;
      }
    }
    .footerBtn {
      text-align: right;
      .dialogWhite {
        width: 145px;
        height: 54px;
      }
      .dialogBtnBackgory {
        width: 145px;
        height: 54px;
        background-color: #008754;
        color: white;
      }
    }
  }
  ::v-deep .el-upload {
    width: 178px;
    height: 178px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  ::v-deep .el-upload:hover {
    border-color: #409eff;
  }
  ::v-deep .el-upload--picture-card {
    line-height: 178px;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
.pageContainer {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.aHref {
  color: #5e92ff;
}
.operate {
  display: flex;
  justify-content: space-around;
  .btn {
    color: #729fff;
  }
}
::v-deep .el-dialog {
  .el-form {
    .el-input {
      width: 770px;
    }
    .el-textarea__inner {
      width: 770px;
    }
  }
}
</style>
